import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  INewWorkType,
  IUpdateWorkType,
  IWorkType,
  IWorkTypeFilter,
} from "@/features/work-types/work-type.types";
import { cleanParams } from "@/utils/cleanParams";

export const workTypeService = {
  getWorkTypes(filter?: IWorkTypeFilter): Promise<AxiosResponse> {
    return http.get<IWorkType[]>("/work-types", {
      params: cleanParams(filter),
    });
  },

  createWorkType(payload: INewWorkType): Promise<AxiosResponse> {
    return http.post("/work-types", payload);
  },

  getWorkTypeById(workTypeId: string): Promise<AxiosResponse> {
    return http.get<IWorkType>(`/work-types/${workTypeId}`);
  },

  updateWorkType(
    workTypeId: string,
    payload: IUpdateWorkType
  ): Promise<AxiosResponse> {
    return http.patch(`/work-types/${workTypeId}`, payload);
  },

  seedDefaultWorkType(): Promise<AxiosResponse> {
    return http.post("/work-types/seed-default");
  },
};
